import { Star } from 'lucide-react'
import { cn } from '@/lib/utils'

interface RatingChipProps {
    rating: number
    reviews?: number
    className?: string
}

export const RatingChip = ({ rating, reviews, className }: RatingChipProps) => {
    return (
        <span
            className={cn('glass inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-xs font-medium text-cream', className)}
            aria-label={`Rated ${rating.toFixed(1)} out of 5${reviews ? ` from ${reviews} reviews` : ''}`}
        >
            <Star aria-hidden='true' className='size-3.5 fill-citron text-citron' />

            <span aria-hidden='true' className='tabular-nums'>
                {rating.toFixed(1)}
            </span>

            {reviews !== undefined && (
                <span aria-hidden='true' className='text-cream/55 tabular-nums'>
                    ({reviews})
                </span>
            )}
        </span>
    )
}
